import { SidenavSection } from "../../parts/sidenav-nav.model";

/**
 * Super User admin menu, rendered by `app-sidenav-group` inside the home view.
 * Add / remove / reorder items by editing this array — no markup changes needed.
 * All items route under the `super-user` segment except exchange-rates, which
 * lives in this menu but routes under `home` (see `absoluteSegments`).
 */
export const SUPER_USER_SECTIONS: SidenavSection[] = [
    {
        id: "organization",
        subheadingKey: "ADMIN.SUPER_USER.GROUPS.ORGANIZATION",
        items: [
            { labelKey: "ADMIN.SUPER_USER.USERS", icon: "users", segments: ["super-user", "users"] },
            { labelKey: "ADMIN.SUPER_USER.COMPANY_TABLE", icon: "building", segments: ["super-user", "company"] },
            { labelKey: "ADMIN.SUPER_USER.FINANCING_COMPANY", icon: "credit-card", segments: ["super-user", "financing-company"] },
        ],
    },
    {
        id: "finance-terms",
        subheadingKey: "ADMIN.SUPER_USER.GROUPS.FINANCE_TERMS",
        items: [
            { labelKey: "ADMIN.SUPER_USER.CURRENCY_TABLE", icon: "money-bill", segments: ["super-user", "currency-table"] },
            { labelKey: "ADMIN.SUPER_USER.INTEREST_RATE", icon: "percentage", segments: ["super-user", "interest-rate"] },
            { labelKey: "HEADER.EXCHANGE_RATES", icon: "arrow-right-arrow-left", segments: [], absoluteSegments: ["home", "exchange-rates"] },
            { labelKey: "ADMIN.SUPER_USER.TERMS.TITLE", icon: "file-pdf", segments: ["super-user", "terms"] },
            { labelKey: "ADMIN.SUPER_USER.PAYMENT_TERMS", icon: "receipt", segments: ["super-user", "payment-terms"] },
            { labelKey: "ADMIN.SUPER_USER.DELIVERY_TERMS", icon: "truck", segments: ["super-user", "delivery-terms"] },
            { labelKey: "ADMIN.SUPER_USER.SALES_CREDIT_ROLES", icon: "share-alt", segments: ["super-user", "sales-credit-roles"] },
        ],
    },
    {
        id: "regional",
        subheadingKey: "ADMIN.SUPER_USER.GROUPS.REGIONAL",
        items: [
            { labelKey: "ADMIN.SUPER_USER.COUNTRIES.TITLE", icon: "globe", segments: ["super-user", "countries"] },
        ],
    },
    {
        id: "quotes",
        subheadingKey: "ADMIN.SUPER_USER.GROUPS.QUOTES",
        items: [
            { labelKey: "ADMIN.SUPER_USER.QUOTE_SEARCH.TITLE", icon: "search", segments: ["super-user", "quotes"] },
        ],
    },
];
